import React, { useEffect } from "react";
 
import Navbar from "../components/homepage/Navbar";
import DroneSpaceMap from "../components/droneSpace/DroneSpaceMap";

const DroneSpace = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div>
      {/* <div className="bg_darkblue">
         <Header />
     </div> */}
      <DroneSpaceMap />
      {/* <Footer/> */}
    </div>
  );
};

export default DroneSpace;
